import React, { useEffect, useState } from 'react';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box } from '@mui/material';

const ArrowBtn = () => {
  const [showButton, setShowButton] = useState(false);
  const [footerPosition, setFooterPosition] = useState(0);

  const handleScroll = () => {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    // const windowHeight = window.innerHeight;
    // const bodyHeight = document.body.clientHeight;

    setShowButton(scrollY > 700 );
  };

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    const footerElement = document.getElementById('yourFooterId');  
    if (footerElement) {
      setFooterPosition(footerElement.offsetTop);
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {showButton && (
        <Box
          className="loadUpBtn"
          onClick={handleClick}>
          <ArrowUpwardIcon />
        </Box>
      )}
    </>
  );
};

export default ArrowBtn;
